<div
  class="search-result-view" id="searchResultViews"
  [ngClass]="searchContainer.searchResultViewName + '-view'"
>
  @if (searchContainer.searching) {
    <div class="search-result-view__spinner-container">
      <div class="search-result-view__spinner-content">
        <mat-spinner
          color="accent"
          diameter="30"
        ></mat-spinner>

        <p>
          {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
        </p>
      </div>
    </div>
  }
  @else {
    @if (searchContainer && searchContainer.searchResult) {
      <div class="h-full">
        @if (searchContainer.searchResult.search_count === 0) {
          <div class="search-result-view__no-results-container">
            <h3 class="search-result-view__no-results-heading">
              {{ 'TRANS__SEARCH_RESULT__NO_SEARCH_HITS' | translate }}
            </h3>

            <h5>
              {{ noSearchResultText | translate }}
            </h5>
          </div>
        }
        @else if (searchContainer.searchResult.search_count > 0) {
          <div class="h-full">
            @if (searchContainer.scrollInfo.searchingScroll && searchContainer.scrollInfo.searchingScrollDir === 'up') {
              <div class="searching-scroll-loader searching-scroll-loader__top">
                <mat-spinner
                  color="accent"
                  diameter="30"
                ></mat-spinner>

                <p class="searching-scroll-loader__info">
                  {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
                </p>
              </div>
            }

            <ng-container>
              @switch (searchContainer.searchResultViewName) {
                @case (SearchResultViewNames.THUMBNAIL) {
                  <app-search-result-view-thumbnail
                    class="h-full block"
                    [width]="containerWidth"
                    [searchContainer]="searchContainer">
                  </app-search-result-view-thumbnail>
                }

                @case (SearchResultViewNames.GALLERY) {
                  <app-search-result-view-gallery
                    class="h-full block"
                    [width]="containerWidth"
                    [searchContainer]="searchContainer"
                  ></app-search-result-view-gallery>
                }

                @case (SearchResultViewNames.LIST_THUMBNAIL) {
                  <app-search-result-view-list-thumbnail
                    class="h-full block"
                    [width]="containerWidth"
                    [searchContainer]="searchContainer"
                  ></app-search-result-view-list-thumbnail>
                }

                @case (SearchResultViewNames.LIST) {
                  <app-search-result-view-list
                    class="search-result-view__list h-full block"
                    [searchContainer]="searchContainer"
                  ></app-search-result-view-list>
                }

                @case (SearchResultViewNames.SELECTOR) {
                  <app-search-result-view-list-selector
                    class="h-full block"
                    [searchContainer]="searchContainer">
                  </app-search-result-view-list-selector>
                }
              }
            </ng-container>


            @if (searchContainer.scrollInfo.searchingScroll && searchContainer.scrollInfo.searchingScrollDir === 'down') {
              <div class="searching-scroll-loader">
                <mat-spinner
                  color="accent"
                  diameter="30"
                ></mat-spinner>

                <p class="searching-scroll-loader__info">
                  {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
                </p>
              </div>
            }
          </div>
        }
      </div>
    }
  }
</div>
